<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  titulo="Confirmar Alterações",
  :max-width="maxWidth",
  persistent,
  :mostrar-fechar="false",
  texto-confirmar="Confirmar",
  :confirmar-desabilitado="!motivoValido",
  @confirmar="$emit('confirmar')"
)
  .mb-3.dialog-texto {{ textoIntroducao }}

  v-card.pa-2(outlined, elevation="0")
    .text-body-2.font-weight-bold Cliente:
    .font-weight-regular {{ cliente ? cliente.nome : "" }}

    .text-body-2.font-weight-bold.pt-2 Empresas:
    .envio-empresas-list.mt-1(v-if="empresas.length > 0")
      .envio-empresa-item.d-flex.align-center(
        v-for="empresa in empresas",
        :key="empresa.codigoempresa"
      )
        span.envio-empresa-codigo {{ empresa.codigoempresa }}
        span.mx-1 —
        span.envio-empresa-nome {{ empresa.fantasia || empresa.razaosocial }}
    .envio-empresas-empty.text-center.py-1(v-else)
      span.text-body-2.grey--text Nenhuma empresa selecionada

    //- Campos extras específicos da tela (ex.: módulo selecionado)
    slot(name="info-adicional")

    .text-body-2.font-weight-bold.pt-2 {{ rotuloItens }}:
    .font-weight-regular {{ totalRegistros }} registros alterados

  .mt-2.font-weight-bold Motivo:
  v-text-field.preview-field.envio-motivo.mt-2(
    :value="motivo",
    @input="$emit('update:motivo', $event)",
    placeholder="Informe o motivo da alteração",
    counter,
    :rules="motivoRules",
    outlined,
    dense,
    clearable,
    hide-details
  )
</template>

<script>
import BaseDialog from "./BaseDialog";

export default {
  name: "ConfirmacaoEnvioDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    cliente: {
      type: Object,
      default: null
    },
    empresas: {
      type: Array,
      default: () => []
    },
    totalRegistros: {
      type: Number,
      default: 0
    },
    motivo: {
      type: String,
      default: ""
    },
    rotuloItens: {
      type: String,
      default: "Itens"
    },
    textoIntroducao: {
      type: String,
      default: "Você está prestes a salvar as alterações realizadas."
    },
    minimoMotivo: {
      type: Number,
      default: 10
    },
    maxWidth: {
      type: [String, Number],
      default: 600
    }
  },

  computed: {
    motivoRules() {
      return [
        v =>
          !!(v && v.trim().length >= this.minimoMotivo) ||
          `Informe ao menos ${this.minimoMotivo} caracteres`
      ];
    },

    motivoValido() {
      return !!(this.motivo && this.motivo.trim().length >= this.minimoMotivo);
    }
  }
};
</script>

<style scoped>
.dialog-texto {
  font-size: 13px;
  color: #2c3e50;
}

.envio-empresas-list {
  max-height: 120px;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 0 2px;
}

.envio-empresa-item {
  gap: 4px;
  line-height: 1.2;
}

.envio-empresa-codigo {
  font-size: 12px;
  color: #555;
  font-weight: 600;
  flex-shrink: 0;
}

.envio-empresa-nome {
  font-size: 12px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}
</style>
